import { AuthLayout } from '@/components/auth/auth-layout';
import { AuthentikButton } from '@/components/auth/authentik-button';
import { SignInForm } from '@/components/auth/sign-in-form';
import { ensureAuthConfig } from '@/lib/auth-config';
import { ensureSession } from '@/lib/session';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/signin')({
  beforeLoad: async ({ context }) => {
    const state = await ensureSession(context.queryClient);
    if (state.status === 'authenticated') {
      throw redirect({ to: '/chat' });
    }
  },
  // Resolve the auth mode before render so the page never flashes the wrong
  // login UI. SSO on => Authentik button; off => email/password form.
  loader: async ({ context }) => ({ authConfig: await ensureAuthConfig(context.queryClient) }),
  component: SignInRoute,
});

function SignInRoute() {
  const { authConfig } = Route.useLoaderData();
  return (
    <AuthLayout testId="signin-route">
      {authConfig.ssoEnabled ? <AuthentikButton label={authConfig.loginLabel} /> : <SignInForm />}
    </AuthLayout>
  );
}
